package com.hipsheep.kore.coroutine

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

public actual val Dispatchers.CoreIO: CoroutineDispatcher
    get() = Default